var map = {
	"./angular-stories.png": 3361,
	"./atp-extension.png": 1606,
	"./covidtrackerdemo.png": 9703,
	"./dark-mode-demo.png": 9723,
	"./eco-insights.png": 1896,
	"./front-app.png": 9260,
	"./gmail-clone.png": 777,
	"./medium-fam-chatbot.png": 3,
	"./tell-me-a-story.png": 9269,
	"./trip-app.png": 3240,
	"./weather-app-ui.png": 4102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5352;